import React from "react";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { BadgeCheck } from "lucide-react";

export const GRADES = ["FLD", "E4+", "E1-3", "LIB", "DER", "PUB", "ASM"];

// Internal-only receipt on a number: the evidence grade as a chip, the basis as a hover note.
export function ProvenanceChip({ basis, grade, testid }) {
  if (!basis && !grade) return null;
  return (
    <HoverCard openDelay={120} closeDelay={80}>
      <HoverCardTrigger asChild>
        <span tabIndex={0} data-testid={testid}
          className="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded bg-slate-900 text-[#F4C400] font-mono font-semibold cursor-help transition-transform hover:-translate-y-px">
          <BadgeCheck className="w-2.5 h-2.5" /> {grade || "basis"}
        </span>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-80 p-3" data-testid={testid ? `${testid}-note` : undefined}>
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-[10px] uppercase tracking-wider text-slate-400">Where this number came from</span>
          {grade && <span className="text-[10px] font-mono font-bold px-1.5 py-0.5 rounded bg-slate-900 text-[#F4C400]">{grade}</span>}
        </div>
        <p className="text-xs text-slate-700 leading-relaxed whitespace-pre-wrap">{basis || "No basis note yet."}</p>
        <p className="text-[10px] text-slate-400 mt-2">Internal only. Never prints on the proposal.</p>
      </HoverCardContent>
    </HoverCard>
  );
}

// Basis + grade editor used inside the line editor.
export function ProvenanceFields({ basis, grade, onField, readOnly, idSuffix }) {
  return (
    <div className="rounded-lg border border-dashed border-slate-200 p-3 space-y-2" data-testid={`prov-fields-${idSuffix}`}>
      <span className="text-[10px] uppercase tracking-wide text-slate-500">Where this number came from <span className="normal-case text-slate-400">(internal only)</span></span>
      <div className="grid grid-cols-[1fr_96px] gap-2">
        <input disabled={readOnly} value={basis || ""} onChange={(e) => onField("basis", e.target.value)}
          placeholder="Source, who, when, why" data-testid={`prov-basis-${idSuffix}`}
          className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-2 focus:border-[#003E87] outline-none bg-white" />
        <select disabled={readOnly} value={grade || ""} onChange={(e) => onField("grade", e.target.value || null)}
          data-testid={`prov-grade-${idSuffix}`}
          className="w-full text-xs border border-slate-200 rounded-lg px-2 py-2 focus:border-[#003E87] outline-none bg-white font-mono">
          <option value="">Grade</option>
          {GRADES.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>
      </div>
    </div>
  );
}
